export default __webpack_public_path__ + "static/media/a.69095eaf.png";